<template>
  <div class="skeleton-container">
    <div v-for="i in count" :key="i" class="skeleton-item" :class="variant">
      <div class="skeleton-shimmer"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonLoader',
  props: {
    variant: { type: String, default: 'table-row' },
    count: { type: Number, default: 5 }
  }
}
</script>

<style scoped>
.skeleton-container {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}
.skeleton-item {
  border-radius: var(--radius-lg);
  overflow: hidden;
  position: relative;
}
.skeleton-item.table-row {
  height: 56px;
  background: var(--color-bg-surface);
}
.skeleton-item.card {
  height: 140px;
  background: var(--color-bg-surface);
}
.skeleton-item.stat-card {
  height: 100px;
  background: var(--color-bg-surface);
  border-radius: var(--radius-lg);
}
.skeleton-shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
</style>
